import { Helmet } from "react-helmet-async";

import { configValue } from "../config";

type SeoProps = {
  title: string;
  description: string;
  path?: string;
  noIndex?: boolean;
  structuredData?: Record<string, unknown>;
};

export default function Seo({
  title,
  description,
  path = "/",
  noIndex = false,
  structuredData,
}: SeoProps) {
  const siteUrl = (configValue("PUBLIC_URL") || window.location.origin).replace(
    /\/$/,
    "",
  );
  const pageTitle = title === "DeVerlofkaart" ? title : `${title} | DeVerlofkaart`;
  const canonical = `${siteUrl}${path}`;
  const image = `${siteUrl}/images/verlofkaart-product-overview.png`;
  return (
    <Helmet>
      <html lang="nl" />
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:site_name" content="DeVerlofkaart" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <script type="application/ld+json">
        {JSON.stringify(
          structuredData ?? {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "DeVerlofkaart",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web, iOS, Android",
            inLanguage: "nl-NL",
            url: siteUrl,
          },
        )}
      </script>
    </Helmet>
  );
}
